<footer class="bd-footer text-muted">
  <div class="container">
    <p>{{globals.Store.VendorConfig.FooterText}}</p>
  </div>
</footer>
